import React from "react";
import { Formik } from "formik";
import { Row, Col } from "react-bootstrap";
import * as EmailValidator from "email-validator";
import * as Yup from "yup";
import { useAuthDispatch } from "../Context";
import { useNavigate } from "react-router-dom";

const ValidatedLoginForm = props => {
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();

  const { showForgotPassword = false } = props;

  return (
    <Formik
      initialValues={{ email: props.email, password: props.password }}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          props.handleSubmit(values);
          setSubmitting(false);
        }, 500);
      }}
      //********Handling validation messages yourself*******/
      validate={values => {
        let errors = {};
        if (!values.email) {
          errors.email = "Adresse E-mail nécessaire";
        } else if (!EmailValidator.validate(values.email)) {
          errors.email = "Adresse E-mail invalide";
        }

        const passwordRegex = /(?=.*[0-9])/;
        if (!values.password) {
          errors.password = "Mot de passe nécessaire";
          /* } else if (values.password.length < 2) {
           errors.password =
             "Votre mot de passe doit faire au moins 2 caractères de long.";
         } else if (!passwordRegex.test(values.password)) {
           errors.password =
             "Votre mot de passe doit contenir au moins un caractère spécial.";
         }*/
        }

        return errors;
      }}
      //********Using Yum for validation********/

      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email()
          .required("Required"),
        password: Yup.string().required("No password provided.")
        // .min(2, "Password is too short - should be 8 chars minimum.")
        //.matches(/(?=.*[0-9])/, "Password must contain a number.")
      })}
    >
      {props => {
        const {
          values,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit
        } = props;
        return (
          <Row cols={1}>
            <form className="" onSubmit={handleSubmit}>
              <Col xs={12}>
                <label htmlFor="email" className="form-label">
                  E-mail
                </label>
                <input
                  name="email"
                  type="text"
                  className={`form-control ${errors.email &&
                    touched.email &&
                    "is-invalid"}`}
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.email && touched.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </Col>{" "}
              <Col xs={12}>
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Mot de passe
                  </label>
                  <input
                    name="password"
                    type="password"
                    className={`form-control ${errors.password &&
                      touched.password &&
                      "is-invalid"}`}
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />

                  {errors.password && touched.password && (
                    <div className="invalid-feedback">{errors.password}</div>
                  )}
                </div>
              </Col>
              <Col xs={12}>
                <br />
                <button
                  className="btn btn-cta"
                  type="submit"
                  disabled={isSubmitting}
                >
                  <div clasName="btn-cta-overlay"></div>
                  Connexion
                </button>
                {showForgotPassword === true && (
                  <p
                    className="forgotPassword"
                    onClick={() => navigate("/forgotPassword")}
                  >
                    <a className="callToActionLink">Mot de passe oublié ?</a>
                  </p>
                )}
              </Col>{" "}
              <Col xs={12}>
                <hr />
                <span>
                  Pas encore client ?{" "}
                  <a
                    className="callToActionLink"
                    onClick={() => navigate("/register")}
                  >
                    Essayez Penge
                  </a>{" "}
                  !
                </span>
              </Col>
            </form>
          </Row>
        );
      }}
    </Formik>
  );
};

export default ValidatedLoginForm;
